import React, { useEffect, useState } from "react";
// import SideBarAuthorization from "./SideBarAuthorization";
import { Grid, Button, InputAdornment, IconButton, Stack, Box } from "@mui/material";
import { LoginContainer, LoginDetails, LogoBox, ParentContainer, SignIn4Inner } from "./Authorization.style";
import ThemeColor from "../../theme/ThemeColor";
import { H1FormTitle, H4FormLabel, H5FormLabel, H7TablePrimeContent } from "../../theme/Theme";
import { CustemButton, InputBox } from "../../components/Custom";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { auththunk } from "../../redux/Thunk/authThunk";
import { useDispatch } from "react-redux";
import { EyeCloseIcon, EyeOpenIcon } from "../../components/Icons";
import { setHeaders } from "../../redux/Thunk/axiosHelper";
import validate from "../../validation/validation";
import DisplayError from '../../validation/DisplayError';
import "./Style.css";
import SignInImage from "../../asserts/LoginImage.jpg";
import image from "../../asserts/LALogistic-1.png"
import{setOfficeId} from "../../redux/Slices/userSlice"

const SignIn = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation();
  const [accessToken, setAccessToken] = useState(localStorage.getItem("accessToken"))  
  const [resErr, setResErr] = useState('')
  const [error, setError] = useState([])
  const [state, setState] = useState({
    Email:'',
    Password:'',
  }) 
  const [showPassword, setShowPassword]= useState(true)
  const [loader, setLoader]= useState(false)
  const [loading, setLoading] = React.useState(false);

  function handleClick() {
    setLoading(true);
  }

  const handleState=(e)=>{
    setState({...state,[e.target.name]:e.target.value.trim()})
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleLogin();     
    }
  }

  useEffect(() => {
    if (!accessToken && location.pathname !== '/') {
      navigate('/');
    }
  }, [accessToken, location.pathname]);

  let validation_input = [
    {tagid: 'username', text: state?.Email, regex_name: 'email', required: true, errmsg: 'Please Enter Valid Email Id.'},
    {tagid: 'password', text: state?.Password, required: true, regex_name: 'free_text', min:4, errmsg: 'Please Enter Password.', max:20},  
 ]
   
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLogin=()=>{
   if(validate(validation_input).length==0){
    setLoading(true);
    dispatch(auththunk(state)).then((data)=>{
      if(data?.payload?.success === false){
        setResErr(data?.payload?.message)
        setError([])
        setLoading(false)
        return
      }else{
        setLoading(false)
        const userDetails = data?.payload?.data[0];
        localStorage.setItem('accessToken', data?.payload?.accessToken)
        localStorage.setItem('refreshToken', data?.payload?.refreshToken)
        localStorage.setItem('userdetails', JSON.stringify(userDetails));
        if (userDetails?.OfficeId) {
          dispatch(setOfficeId(userDetails.OfficeId
        ))}
        setHeaders("x-access-token", data?.payload?.accessToken); 
        navigate('/dashboard')
      }
     }
    )   
   }else{
    setError(validate(validation_input))
    setResErr('')
   }  
  }

  const handleCopy = (e) => {
    e.preventDefault();
  }

  return(
    <>
      {/* {accessToken ? '' : */}
       <LoginContainer>
        {/* Display Image */}
        <Grid container>
          <Grid size={{ xs: 12, sm: 10, md: 10, lg:8 }} style={{display:'flex', justifyContent:"center"}}>
            <img src={SignInImage} alt="Login" style={{ width: 'auto', height: '100vh', objectFit: 'cover'}} />
          </Grid>
  
          {/* Employee Login Details */}
          <Grid size={{ xs: 12, sm: 10, md: 10, lg:4}} style={{background:'#F1F1F1',borderBottomRightRadius:'10px', borderTopRightRadius:'10px',height:'auto', maxWidth:'100%'}}>
              <LogoBox>
                <img src={image} width={172} height={165} alt="" style={{objectFit: 'cover'}}/>
              </LogoBox>
              <LoginDetails >
                  <H1FormTitle sx={{color:ThemeColor.palette.BrandColor}}>
                    User Login
                  </H1FormTitle>
                  <InputBox name='Email' onChange={handleState} value={state?.Email} sx={{width:'100%', border:"1px solid #B0AEFF", borderRadius:'10px', p:0.1, mt:2, pl:1}} placeholder ="User Email"/>
                  <DisplayError error={error} fortagid='username'/>
                  <InputBox onPaste={(e) => e.preventDefault()} onCopy={handleCopy} name='Password' type={showPassword ?'password': 'text'} value={state.Password} onChange={handleState} onKeyPress={handleKeyPress} sx={{width:'100%', border:"1px solid #B0AEFF", borderRadius:'10px', p:0.1, mt:3, pl:1}} placeholder ="Password" endAdornment={
                     <InputAdornment position="end">
                        <IconButton style={{ml:1}}  aria-label="toggle password visibility"
                          onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
                          {showPassword ? <EyeCloseIcon /> : <EyeOpenIcon />}
                        </IconButton> 
                     </InputAdornment>
                     }/>
                  <DisplayError error={error} fortagid='password'/> 
                  {resErr?<><small style={{color:'red'}}>{resErr}</small><br/></>:''}

                  <Link to='/forgotpassword' style={{textDecoration:'none'}} >
                    <H7TablePrimeContent sx={{color:ThemeColor.palette.TableButton, mt:3, textAlign:'end'}}>
                      Forgot Password ?
                    </H7TablePrimeContent>
                  </Link>
                  <Box sx={{display:'flex', justifyContent:'center' }}>
                    <Button
                      sx={{width:'100%', height:'40px', textTransform:'none', color:'#FFFFFF', fontSize:'16px', "&:hover": {backgroundColor:'#3107AA'}, backgroundColor:'#3107AA', fontWeight:'500', borderRadius:'10px', marginTop:'20px'}} 
                      size="small"
                      onClick={handleLogin}
                      loading={loading}
                      loadingIndicator="Loading…"
                      variant="contained"
                    >
                    Sign In
                    </Button>
                 </Box> 
              </LoginDetails> 
          </Grid> 
        </Grid>
      </LoginContainer>
      {/* } */}
      </>
  )}

export default SignIn;

